import useCustomHook from '@/hooks/useCustomHook';
import filterThemes from '@/modules/search/filterThemes';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { NavigationContext } from '@/shared/NavigationContext/NavigationContext';
import { ThemesContext } from '@/shared/ThemesContext/ThemesContext';
import { useContext, useEffect } from 'react';

export default function usePublicThemes({ themes }) {
  const globalContext = useContext(GlobalContext);
  const navigationContext = useContext(NavigationContext);
  const themesContext = useContext(ThemesContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      themes: themes.filter(
        (theme) => theme.language == globalContext.state.selectedLanguage
      ),
    },
    actions: {},
  });

  useEffect(() => {
    if (themesContext.state.loaded) {
      actions.setState({
        themes: filterThemes({
          searchText: navigationContext.state.pagesData.themes?.searchText,
          themes: themesContext.state.themes,
          language: globalContext.state.selectedLanguage,
          tagId: navigationContext.state.selectedTagId,
          activityType: navigationContext.state.pagesData.themes?.activityType,
        }),
      });
    }
  }, [
    themesContext.state.loaded,
    themesContext.state.themes,
    navigationContext.state.pagesData.themes?.searchText,
    globalContext.state.selectedLanguage,
    navigationContext.state.selectedTagId,
    navigationContext.state.pagesData.themes?.activityType,
  ]);

  return { state, actions };
}
